<template>
  <div class="add-price-dimension" data-test="add-price-dimension">
    <div class="main-wrapper">
      <div class="dimension-name">
        <van-field
          :formatter="v => v.trimLeft()"
          v-model="editObj.dimensionName"
          placeholder="请输入课程属性名称"
          maxlength="20"
          class="new-height"
        />
      </div>
      <div class="dimension-title">
        属性值
        <van-popover
          v-model="showPopover"
          trigger="click"
          placement="bottom-start"
          theme="dark"
          :offset="[-8, 6]"
        >
          当前课程属性下的选项
          <template #reference>
            <van-icon name="question-o" />
          </template>
        </van-popover>
      </div>
      <div class="option-wrapper">
        <div
          class="option-item van-hairline--bottom"
          v-for="(item, index) in editObj.basePriceDimensionDetailList"
          :key="index"
        >
          <div @click="deleteDimensionItem(index)">
            <van-icon
              class-prefix="vxs-icon"
              name="system_del"
              color="var(--c3)"
            />
          </div>
          <div class="option-name">
            <van-field
              v-model="item.dimensionValue"
              :placeholder="'选项' + (index + 1)"
              maxlength="20"
              :formatter="v => v.trimLeft()"
            />
          </div>
          <div class="option-btn">
            <span>
              <svg class="vxm-icon" aria-hidden="true" @click="addOrder(index)" v-if="index !== 0">
                <use xlink:href="#vxm-icon-system_up"></use>
              </svg>
            </span>
            <span>
              <svg
                class="vxm-icon"
                aria-hidden="true"
                @click="reduceOrder(index)"
                v-if="index !== editObj.basePriceDimensionDetailList.length - 1"
              >
                <use xlink:href="#vxm-icon-system_down"></use>
              </svg>
            </span>
          </div>
        </div>
      </div>
      <div class="add-dimension" @click="addDimensionItem">
        <van-icon class-prefix="vxs-icon" name="system_add" size="var(--fs-md)" color="var(--c1)" />
        新增属性值
      </div>
    </div>
    <page-footer-btn multipleBtns v-if="isEdit">
      <van-button
        block
        plain
        square
        round
        data-test="add-price-dimension-btn-delete"
        @click="deletePriceDimension"
        :loading="btnLoading1"
        loading-text="提交中..."
        v-if="app.permission.op('edit_pirce_dimension')"
        >删除</van-button
      >
      <van-button
        block
        square
        round
        type="primary"
        data-test="add-price-dimension-btn-save"
        @click="updatePriceDimension"
        :loading="btnLoading"
        loading-text="提交中..."
      >
        保存
      </van-button>
    </page-footer-btn>
    <page-footer-btn
      v-else
      @click="addPriceDimension"
      btnText="确定"
      :loading="btnLoading"
      data-test="add-price-dimension-btn-comfirm"
      loading-text="提交中..."
    />
  </div>
</template>

<script>
import pageFooterBtn from '@x3/vue/comp/page-footer-btn.vue';

export default {
  data() {
    return {
      pageTitle: '新增课程属性',
      isEdit: false,
      editObj: {
        dimensionName: '',
        basePriceDimensionDetailList: [
          {
            dimensionValue: '',
          },
          {
            dimensionValue: '',
          },
        ],
        sort: 1,
        defaultDimension: false,
        priceDimensionStatus: 1,
        deleted: false,
      },
      deleteList: [],
      btnLoading: false,
      btnLoading1: false,
      showPopover: false,
    };
  },
  methods: {
    addOrder(index) {
      this.editObj.basePriceDimensionDetailList[index] =
        this.editObj.basePriceDimensionDetailList.splice(
          index - 1,
          1,
          this.editObj.basePriceDimensionDetailList[index]
        )[0];
    },
    reduceOrder(index) {
      this.editObj.basePriceDimensionDetailList[index] =
        this.editObj.basePriceDimensionDetailList.splice(
          index + 1,
          1,
          this.editObj.basePriceDimensionDetailList[index]
        )[0];
    },
    addDimensionItem() {
      this.editObj.basePriceDimensionDetailList.push({ dimensionValue: '' });
    },
    deleteDimensionItem(index) {
      if (this.editObj.basePriceDimensionDetailList.length === 1) {
        return;
      }
      const _itemObj = this.editObj.basePriceDimensionDetailList.splice(index, 1)[0];
      if (this.isEdit && _itemObj.id) {
        _itemObj.deleted = true;
        this.deleteList.push(_itemObj);
      }
    },
    verifyRequest() {
      if (!this.editObj.dimensionName.trim()) {
        this.$toast('属性名称不能为空');
        return false;
      }
      if (
        this.editObj.basePriceDimensionDetailList.find(
          v => v.dimensionValue === undefined || v.dimensionValue === ''
        )
      ) {
        this.$toast('属性值不能为空');
        return false;
      }
      if (this.editObj.basePriceDimensionDetailList.length === 0) {
        this.$toast('请添加属性值');
        return false;
      } else {
        // 判断数组中是否存在属性值dimensionValue相同的项
        const _list = this.editObj.basePriceDimensionDetailList.map(item => {
          return item.dimensionValue;
        });
        const result = _list.every(function (item, index) {
          return _list.indexOf(item, 0) === index;
        });
        if (!result) {
          this.$toast.fail('属性值重名');
        }
        return result;
      }
    },
    emitAfterEdit() {
      app.vue.$emit('refresh-price-list');
      this.$router.back();
    },
    deletePriceDimension() {
      this.btnLoading1 = true;
      this.$api
        .basePriceDimensionDelete({
          id: this.$route.query.id,
        })
        .then(res => {
          if (res.code === 200) {
            this.$toast.success('删除成功');
            this.emitAfterEdit();
          } else {
            this.$toast.fail(res.msg);
          }
        })
        .finally(() => {
          this.btnLoading1 = false;
        });
    },
    addPriceDimension() {
      if (!this.verifyRequest()) return;
      this.btnLoading = true;
      this.$api
        .basePriceDimensionCreate(this.editObj)
        .then(res => {
          if (res.code === 200) {
            this.$toast.success('新增成功');
            app.vue.$emit('add-price-dimension', {
              id: res.data.id,
              dimensionName: res.data.dimensionName,
              basePriceDimensionDetailList: res.data.basePriceDimensionDetailList,
            });
            this.emitAfterEdit();
          } else {
            this.$toast.fail(res.msg);
          }
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    async updatePriceDimension() {
      if (!this.verifyRequest()) return;
      if (this.odlEditObj === JSON.stringify(this.editObj)) {
        this.$router.back();
        return false;
      }
      let confirmRes;
      try {
        confirmRes = await vant.Dialog.confirm({ 
          title: '是否确认修改？',
          message: '如果您修改/删除的属性值已被课程使用，确认修改后，课程上的设置的属性值也将同步修改/删除，无法恢复。'
        });
      } catch (err) {
        confirmRes = false;
      }
      if (!confirmRes) return false;
      const params = app.tool.clone(this.editObj);
      params.basePriceDimensionDetailList.forEach(item => {
        if (item.oname === item.dimensionValue) {
          item.changed = false;
        } else if (item.oname) {
          item.changed = true;
        }
      });
      params.basePriceDimensionDetailList.push(...this.deleteList);
      this.btnLoading = true;
      this.$api
        .basePriceDimensionUpdate(params)
        .then(res => {
          if (res.code === 200) {
            this.$toast.success('修改成功');
            this.emitAfterEdit();
          } else {
            this.$toast.fail(res.msg);
          }
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    getBasePriceDimensionListId() {
      this.$api
        .basePriceDimensionListId({
          basePriceDimensionId: this.$route.query.id,
        })
        .then(res => {
          vant.Toast.clear();
          if (res.code === 200) {
            const _data = res.data;
            _data.basePriceDimensionDetailList.forEach(item => {
              item.oname = item.dimensionValue;
            });
            this.editObj = res.data;
            this.odlEditObj = JSON.stringify(res.data);
          }
        });
    },
  },
  created() {
    if (this.$route.query.id) {
      this.isEdit = true;
      this.showLoading();
      this.pageTitle = '修改课程属性';
      this.getBasePriceDimensionListId();
    } else {
      this.editObj.priceDimensionStatus = !Boolean(Number(this.$route.query.disableEnable));
    }
  },
  components: {
    pageFooterBtn,
  },
};
</script>

<style lang="scss" scoped>
.add-price-dimension {
  background-color: var(--g1);
  display: flex;
  flex-direction: column;
  .main-wrapper {
    flex: 1;
    overflow-y: scroll;
    .dimension-name {
      background-color: var(--white);
      .new-height {
        font-size: var(--fs-ex1);
        line-height: var(--lh-ex1);
      }
    }
    .dimension-title {
      display: flex;
      align-items: center;
      padding: calc(var(--gap) * 16);
      font-size: var(--fs-md);
      line-height: var(-lh-md);
    }
    .add-dimension {
      padding: calc(var(--gap) * 16);
      color: var(--c1);
      background-color: var(--white);
    }
    .option-wrapper {
      padding: 0 calc(var(--gap) * 16);
      background-color: var(--white);
      .option-item {
        display: flex;
        align-items: center;
        font-size: var(--fs-md);
        line-height: var(--lh-md);
        box-sizing: content-box;
        .option-name {
          flex: 1;
        }
        .option-btn {
          font-size: 24px;
          & > span {
            display: inline-block;
            width: 24px;
            height: 24px;
            margin-left: calc(var(--gap) * 8);
          }
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.add-price-dimension {
  .dimension-title {
    .van-popover__wrapper {
      padding-left: calc(var(--gap) * 2);
      display: flex;
      align-items: center;
    }
  }
}
</style>